import { render } from "./ProjectsPage.vue?vue&type=template&id=66933bee&ts=true"
import script from "./ProjectsPage.vue?vue&type=script&lang=ts"
export * from "./ProjectsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__